import {sourcingStorageKey} from '../constants/sourcingStorageKey';
import {getPreviewLayoutStorageKeys} from './getPreviewLayoutStorageKeys';

const KEPT_KEYS: ReadonlyArray<string> = [
  sourcingStorageKey.FILTERS,
  sourcingStorageKey.FILTER_PRESET_ID,
  sourcingStorageKey.FILTER_PRESETS_EXPANDED,
  ...Object.values(getPreviewLayoutStorageKeys(sourcingStorageKey.PREVIEW_LAYOUT_PREFIX)),
  ...Object.values(getPreviewLayoutStorageKeys(sourcingStorageKey.DETAIL_PREVIEW_LAYOUT_PREFIX)),
];

const KEPT_KEY_PREFIXES: ReadonlyArray<string> = [
  sourcingStorageKey.TABLE_SORTING_PREFIX,
  sourcingStorageKey.TABLE_REAL_TIME_PREFIX,
];

/**
 * Sourcing preferences that survive logout, which otherwise clears the whole localStorage.
 * New sourcing keys are not kept unless they are listed here.
 */
export const isSourcingStorageKeyKeptOnLogout = (key: string) =>
  KEPT_KEYS.includes(key) || KEPT_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
